// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I0tSm{margin-inline-start:32px}.uv6V5{display:flex;align-items:center;justify-content:space-between;gap:4px}.VUVx9{display:flex;align-items:center;gap:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"agreementNotificationBadge": `I0tSm`,
	"title": `uv6V5`,
	"status": `VUVx9`
};
export default ___CSS_LOADER_EXPORT___;
